import { CALCULUS, PERIAPICAL_RADIOLUCENCY } from '../../constants';

const ELLIPSE_FINDING_TYPES = [CALCULUS, PERIAPICAL_RADIOLUCENCY];

interface CornerstonePoint {
  x: number;
  y: number;
}
interface CornerstoneHandles {
  start: CornerstonePoint;
  end: CornerstonePoint;
}

interface AiPrediction {
  xMin: number;
  xMax: number;
  yMin: number;
  yMax: number;
  type: string;
}
interface UserAnnotation {
  handles: CornerstoneHandles;
  type: string;
}

export const isEllipseFinding = (findingType: string): boolean => {
  return ELLIPSE_FINDING_TYPES.includes(findingType);
};

export function computePointsArrayFromBorderedFinding(
  finding: UserAnnotation | AiPrediction,
): any {
  if ('handles' in finding) {
    const { handles } = finding;
    // This identifies a user finding
    const { start, end } = handles;
    return [
      [start.x, start.y],
      [start.x, end.y],
      [end.x, start.y],
      [end.x, end.y],
    ];
  }

  const { type, xMin, xMax, yMin, yMax } = finding;
  if (isEllipseFinding(type)) {
    // This identifies something that'll be drawn as an ellipse
    return [
      [(xMin + xMax) / 2, yMin],
      [(xMin + xMax) / 2, yMax],
      [xMin, (yMin + yMax) / 2],
      [xMax, (yMin + yMax) / 2],
    ];
  }

  return [
    [xMin, yMin],
    [xMin, yMax],
    [xMax, yMin],
    [xMax, yMax],
  ];
}
